/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unstable-nested-components */
import React, { useState, useEffect, useRef, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Divider } from "antd";
import CustomTable from "../../Core/Components/CustomTable";
import CustomLayout from "../../Core/Layout/CustomLayout";
import { BatteryKPIData, batteriesColumns } from "./Data/BatteryListData";
import CustomKPI from "../../Core/Components/CustomKpi";
import {
  getAllBatteriesV3,
  getBatteryV3,
  getKPI,
} from "../../Redux/APIs/batteriesAPI";
import { updateBatteries } from "../../Redux/Slices/batteries.slice";
import BatteryIcon from "../../Common/Svgs/BatteryIcon";
import BatteryListHeader from "./phase3/BatteryListHeader";
import ToastMessageModal from "./phase3/ToastMessageModal";
import ChevronIcon from "../../Common/Svgs/ChevronIcon";
import DeleteBatteryModal from "./phase3/DeleteBatteryModal";
import usePermission from "../../Core/hooks/usePermission";
import { PERMISSIONS } from "../Login/constants";
import QRCodeModal from "../../Core/Components/Modal/QRCodeModal";
import { updateQrCode } from "../../Redux/Slices/qrcode.slice";
import { getUserByEmail } from "../../Redux/APIs/systemUsersAPI";
import useDebounce from "../../Core/hooks/useDebounce";
import AcceptBatteryRequestModal from "./phase3/AcceptBatteryRequestModal";
import AssignPickupAgentModal from "./phase3/AssignPickupAgentModal";
import { getTableContainerHeight } from "../../Utils/getTableContainerHeight";
import { getAllLocationsV3 } from "../../Redux/APIs/locationsAPI";
import RetireBatteryModal from "./phase3/RetireBatteryModal";
import UnretireBatteryModal from "./phase3/UnretireBatteryModal";
import { LOCATION_TYPE } from "../Location/Data";
import TrashIcon from "../../Common/Svgs/TrashIcon";
import SetupContainerView from "./phase3/SmartContainers/SetupContainerView";
import ContainerOverviewView from "./phase3/SmartContainers/ContainerOverviewView";
import { getSmartContainerLayout } from "../../Redux/APIs/smartContainersAPI";
import ArrowIcon from "../../Common/Svgs/ArrowIcon";
import { updateHub } from "../../Redux/Slices/hubs.slice";

const LOCAL_DEFAULT_LIMIT = 10;

function SmartContainers() {
  const dispatch = useDispatch();

  const { allLocations } = useSelector((state) => state.locations);
  const { userDetails } = useSelector((state) => state.loggedInUser);

  const { id } = useParams();

  const { selectedHub } = useSelector((state) => state.hubs);
  const [rows, setRows] = useState(5);
  const [columns, setColumns] = useState(5);

  const hubs = useMemo(() => {
    return allLocations
      .filter(
        (item) =>
          item.type === LOCATION_TYPE.HUB_STATION &&
          userDetails.hubs.includes(item.id),
      )
      .map((location) => ({
        id: location.id,
        value: location.name,
      }));
  }, [allLocations, userDetails.hubs]);

  useEffect(() => {
    if (hubs.length > 0 && selectedHub === undefined) {
      dispatch(
        updateHub({
          key: "selectedHub",
          value: hubs[0].id,
        }),
      );
    }
  }, [hubs]);

  const HUBS_PER_PAGE = 4;

  const [currentHubPage, setCurrentHubPage] = useState(0);

  const totalPages = Math.ceil(hubs.length / HUBS_PER_PAGE);

  const { smartContainerLayout } = useSelector((state) => state.batteries);
  const currentHubData = smartContainerLayout;

  const navigate = useNavigate();

  useEffect(() => {
    if (selectedHub) {
      dispatch(getSmartContainerLayout({ hubId: selectedHub }));
    }
  }, [selectedHub, dispatch]);

  useEffect(() => {
    if (id && currentHubData?.layout) {
      setRows(currentHubData.layout.rows);
      setColumns(currentHubData.layout.columns);
    }
  }, [id, currentHubData]);

  const {
    batteryListV3,
    kpiData,
    showToastMessage,
    deleteBatteryModal,
    acceptBatteryRequestModal,
    assignPickupAgentModal,
    retireBatteryModal,
    unretireBatteryModal,
  } = useSelector((state) => state.batteries);

  const { viewModal } = useSelector((state) => state.qrCode);

  const tableContainerRef = useRef();

  const [slideDirection, setSlideDirection] = useState("");

  const [showKpi, setShowKpi] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [filters, setFilters] = useState({
    hub: [],
    battery: [],
    status: [],
    driver: [],
    dateRangeStart: "",
    dateRangeEnd: "",
    addedBy: [],
  });

  // check if the user has permission to acccess the module
  const hasPermission = usePermission([
    PERMISSIONS.BATTERY_VIEW,
    PERMISSIONS.BATTERY_VIEW_AND_EDIT,
  ]);

  // check if the user has permission to acccess the service module
  const hasServicePermission = usePermission([
    PERMISSIONS.SERVICE_VIEW,
    PERMISSIONS.SERVICE_VIEW_AND_EDIT,
  ]);

  const debounceSearch = useDebounce(search, 500);

  const handleRowClick = (record) => {
    const current = batteryListV3.result.find((item) => item.id === record.id);

    if (hasPermission) {
      dispatch(
        updateBatteries({
          key: "currentBattery",
          value: current,
        }),
      );

      // navigate(`/batteries/${record.registrationNo}`);
      navigate(`/batteries/${record.id}`);
    }
  };

  // fetch the kpi data
  useEffect(() => {
    dispatch(getKPI());
  }, [dispatch]);

  // fetch the battery list on every page change
  useEffect(() => {
    const filterObj = {
      offset: ((currentPage || 1) - 1) * LOCAL_DEFAULT_LIMIT,
      limit: LOCAL_DEFAULT_LIMIT,
    };

    if (debounceSearch) filterObj.searchQuery = debounceSearch;
    if (filters.hub.length) filterObj.hubs = filters.hub;
    if (filters.driver.length) filterObj.drivers = filters.driver;
    if (filters.battery.length) filterObj.batteryPercentage = filters.battery;
    if (filters.status.length) filterObj.status = filters.status;
    if (filters.dateRangeStart && filters.dateRangeEnd) {
      filterObj.dateRangeStart = filters.dateRangeStart;
      filterObj.dateRangeEnd = filters.dateRangeEnd;
    }
    if (filters.addedBy.length) {
      filterObj.addedBy = filters.addedBy.map((user) => user.id);
    }

    dispatch(getBatteryV3(filterObj));
  }, [dispatch, currentPage, filters, debounceSearch]);

  // close the toast message after 5 seconds
  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(
        updateBatteries({
          key: "showToastMessage",
          value: {
            visible: false,
            data: {},
          },
        }),
      );
    }, 5000);

    return () => clearTimeout(timeout);
  }, [dispatch, showToastMessage.visible]);

  // fetch user details and all the locations (to get permissions on every refresh)
  useEffect(() => {
    dispatch(getUserByEmail({ email: userDetails.email }));
    dispatch(getAllBatteriesV3());

    setTimeout(() => {
      dispatch(getAllLocationsV3());
    }, 3000);
  }, [dispatch]);

  return (
    <CustomLayout pageName="Batteries" nestedName="Smart Container">
      <div className="bg-background flex items-center">
        <div className="flex items-center flex-1 h-[92px] p-6 gap-3 overflow-hidden">
          <div className="overflow-x-hidden overflow-y-visible w-[720px] py-2 px-1.5">
            <div
              className="flex transition-transform duration-500 ease-in-out"
              style={{
                transform: `translateX(-${currentHubPage * 100}%)`,
              }}
            >
              {Array.from({ length: totalPages }).map((_, pageIndex) => {
                const pageHubs = hubs.slice(
                  pageIndex * HUBS_PER_PAGE,
                  pageIndex * HUBS_PER_PAGE + HUBS_PER_PAGE,
                );

                return (
                  <div className="grid grid-cols-4 gap-3 min-w-full px-1">
                    {pageHubs.map((hub) => (
                      <span
                        key={hub.id}
                        onClick={() => {
                          dispatch(
                            updateHub({
                              key: "selectedHub",
                              value: hub.id,
                            }),
                          );
                          navigate("/batteries/smart-containers");
                        }}
                        className={`rounded-md px-6 py-3 font-poppins font-medium text-xs leading-none cursor-pointer shadow-[2px_2px_8px_0px_#0000001A] h-11 flex items-center justify-center whitespace-nowrap ${
                          selectedHub === hub.id
                            ? "bg-primary text-white"
                            : "bg-[#FCFCFC] text-[#525252]"
                        }`}
                      >
                        {hub.value}
                      </span>
                    ))}
                  </div>
                );
              })}
            </div>
          </div>

          <div className="flex items-center gap-2 shrink-0">
            <button
              type="button"
              onClick={() => setCurrentHubPage((page) => Math.max(page - 1, 0))}
              disabled={currentHubPage === 0}
              className={`p-2 rounded rotate-180 ${
                currentHubPage === 0
                  ? "opacity-40 bg-light-grey"
                  : "cursor-pointer hover:bg-light-grey"
              }`}
            >
              <ChevronIcon strokeWidth="1.5" className="w-4 h-4 stroke-black" />
            </button>

            <button
              type="button"
              onClick={() =>
                setCurrentHubPage((page) => Math.min(page + 1, totalPages - 1))
              }
              disabled={currentHubPage === totalPages - 1}
              className={`p-2 rounded ${
                currentHubPage === totalPages - 1
                  ? "opacity-40 bg-light-grey"
                  : "cursor-pointer hover:bg-light-grey"
              }`}
            >
              <ChevronIcon strokeWidth="1.5" className="w-4 h-4 stroke-black" />
            </button>
          </div>
        </div>
        <button
          type="button"
          className="px-3 py-2.5 bg-background hover:bg-light-grey rounded-md border-light-grey border mr-6 shrink-0"
          onClick={() => navigate("/batteries")}
        >
          <div className="flex items-center gap-x-2 w-[76px] h-[18px]">
            <img
              src="/assets/icons/battery/row-vertical.svg"
              className="w-4 h-4"
              alt=""
            />

            <p className="font-poppins text-xs leading-none font-medium text-black">
              List View
            </p>
          </div>
        </button>
      </div>
      {currentHubData?.setupCompleted && !id ? (
        <ContainerOverviewView
          layout={currentHubData?.layout}
          lockers={currentHubData?.lockers}
          selectedHub={selectedHub}
          selectedHubName={hubs.find((hub) => hub.id === selectedHub)?.value}
        />
      ) : (
        <SetupContainerView
          rows={rows}
          columns={columns}
          setRows={setRows}
          setColumns={setColumns}
          lockers={currentHubData?.lockers}
          id={id}
        />
      )}

      <DeleteBatteryModal
        visible={deleteBatteryModal}
        onCancel={() =>
          dispatch(
            updateBatteries({
              key: "deleteBatteryModal",
              value: false,
            }),
          )
        }
        batteryCurrentPage={currentPage}
        setBatteryCurrentPage={setCurrentPage}
      />

      <QRCodeModal
        visible={viewModal?.visible}
        type={viewModal?.data?.assetType}
        onCancel={() =>
          dispatch(
            updateQrCode({
              key: "viewModal",
              value: { visible: false, data: {} },
            }),
          )
        }
      />

      <AcceptBatteryRequestModal
        visible={acceptBatteryRequestModal?.visible}
        onCancel={() =>
          dispatch(
            updateBatteries({
              key: "acceptBatteryRequestModal",
              value: {
                visible: false,
                data: {},
              },
            }),
          )
        }
      />

      <AssignPickupAgentModal
        visible={assignPickupAgentModal?.visible}
        onCancel={() =>
          dispatch(
            updateBatteries({
              key: "assignPickupAgentModal",
              value: {
                visible: false,
                data: {},
              },
            }),
          )
        }
      />

      <RetireBatteryModal
        visible={retireBatteryModal}
        onCancel={() =>
          dispatch(
            updateBatteries({
              key: "retireBatteryModal",
              value: false,
            }),
          )
        }
        batteryCurrentPage={currentPage}
        setBatteryCurrentPage={setCurrentPage}
      />

      <UnretireBatteryModal
        visible={unretireBatteryModal}
        onCancel={() =>
          dispatch(
            updateBatteries({
              key: "unretireBatteryModal",
              value: false,
            }),
          )
        }
        batteryCurrentPage={currentPage}
        setBatteryCurrentPage={setCurrentPage}
      />

      <ToastMessageModal
        visible={showToastMessage?.visible}
        onCancel={() =>
          dispatch(
            updateBatteries({
              key: "showToastMessage",
              value: { visible: false, data: {} },
            }),
          )
        }
        title={showToastMessage?.data?.title}
        description={showToastMessage?.data?.description}
      />
    </CustomLayout>
  );
}
export default SmartContainers;
